module.exports = __webpack_public_path__ + "img/logo-long.dbdc0944.png";